<template>
  <div class="inline underline transition text-sm cursor-pointer">
    {{ name }}
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    name: String,
  },
})
export default class TextLink extends Vue {}
</script>
